import { Outlet } from 'react-router';

import { lazyScreen } from '@/lib/lazyScreen';

import { isContactVerificationRequired } from './contactVerification';
import { useAuth } from './useAuth';

/**
 * Het kantoorscherm laadt pas als de stap open staat, en nooit in de keten van `/monteur` (P-10): een dynamische
 * import buiten `features/fitter/`.
 */
const ContactVerificationPage = lazyScreen(
    () => import('@/features/auth/contactVerification/ContactVerificationPage'),
    'ContactVerificationPage',
    true,
);

/**
 * Story `be-fe-contactgegevens-bevestigen` (AC 7) — de poort van de kantoor-app. Zolang whoami
 * `contactVerificationRequired === true` meldt, toont hij in plaats van élke pagina het scherm "Vul je
 * contactgegevens aan". Geen eigen URL en geen redirect: het adres blijft staan, en na afronden (whoami zonder het
 * veld) staat de gevraagde pagina er gewoon.
 *
 * <b>Hij staat DIRECT boven `<Chrome>`</b> (onder `FitterOnlyRouteGuard`, zodat een alleen-monteur eerst naar
 * `/monteur` gaat en daar de monteur-variant krijgt). Zo mount de kantoorschil niet, en vertrekken haar calls
 * (meldingenbel, menu, berichten) niet — de backend zou ze allemaal weigeren (pre-flight P-B). De monteur-app heeft
 * zijn eigen poort in `FitterShell`.
 *
 * Een 403 `contact_verification_required` van een andere call zet het veld centraal aan (`AuthProvider`); deze
 * guard leest alleen whoami.
 */
export function ContactVerificationRouteGuard() {
    const { user } = useAuth();
    if (isContactVerificationRequired(user)) return <ContactVerificationPage />;
    return <Outlet />;
}
